import React, { useState, useEffect } from 'react';
import { useSelector, shallowEqual, useDispatch } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import {
  Badge,
  Col, FormFeedback, FormGroup, Input, Label, Button,
} from 'reactstrap';
import TheLayout from '../../layout/TheLayout';
import SuccessModal from '../Util/Modal/SuccessModal';
import FailureModal from '../Util/Modal/FailureModal';
import {
  sendMailResetPassword,
  clearResultFlg,
} from '../../redux/actions/auth';

const keywords = ['TERRA', 'ウイルス対策', '除菌剤', '港区', '赤坂', 'TERRA FORESTA', 'TERRA COAT', '光触媒コーディング （編集済み）'];

const ResetPw = () => {
  const [email, setEmail] = useState('');
  const [emailErr, setEmailErr] = useState('');
  const isSuccess = useSelector((state) => state.auth.isSuccess, shallowEqual);
  const isFailure = useSelector((state) => state.auth.isFailure, shallowEqual);
  const errorMessage = useSelector((state) => state.auth.errorMessage, shallowEqual);
  const history = useHistory();
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo(0, 0);
  });

  const closeResultModal = () => {
    dispatch(clearResultFlg());
  };

  const gotoHome = () => {
    dispatch(clearResultFlg());
    history.push('/');
  };

  const onSubmit = () => {
    let isInvalid = false;
    setEmailErr('');
    if (email === '') {
      setEmailErr('メールを入力してください');
      isInvalid = true;
    // eslint-disable-next-line no-useless-escape
    } else if (!email.match(/^([a-zA-Z0-9])+([a-zA-Z0-9\.+_-])*@([a-zA-Z0-9_-])+([a-zA-Z0-9\._-]+)+$/)) {
      setEmailErr('メールアドレスが不正です');
      isInvalid = true;
    }

    if (isInvalid) return;
    const param = {
      email,
      company_id: Number(process.env.REACT_APP_COMPANY_ID),
    };
    dispatch(sendMailResetPassword(param));
  };

  return (
    <TheLayout>
      <Helmet
        meta={[{
          name: 'keyword',
          content: keywords.join(),
        }]}
      >
        <title>パスワード再設定｜株式会社TERRA</title>
      </Helmet>
      <div className="resetPw" style={{ background: 'rgb(235, 244, 246)' }}>
        <div className="d-none d-lg-block">
          <div className="container pl-0">
            <nav>
              <ol className="breadcrumb bg-transparent" style={{ color: 'rgb(181,189,185)', background: 'rgb(235, 244, 246)!important' }}>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/">ホーム</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li className="breadcrumb-item">
                  <Link style={{ textDecoration: 'none', color: 'rgb(181,189,185)' }} to="/mypage">マイページ</Link>
                </li>
                <li className="mx-2">&#62;</li>
                <li>パスワード再設定</li>
              </ol>
            </nav>
          </div>
        </div>
        <div className="container p-2 p-md-5">
          <div
            className="information bg-white px-3 px-lg-5"
            style={{
              borderRadius: '1rem',
            }}
          >
            <h4 className="row border-bottom py-2 pl-2" style={{ color: 'rgb(71,108,138)' }}>パスワード再設定</h4>
            <div className="row border-bottom py-2">
              <Col form>
                <FormGroup row>
                  <Label for="currentPw" lg={4}>
                    メールアドレス
                    {' '}
                    <Badge color="danger">
                      必須
                    </Badge>
                  </Label>
                  <Col lg={8}>
                    <Input
                      invalid={emailErr !== ''}
                      onChange={(e) => {
                        setEmailErr('');
                        setEmail(e.target.value);
                      }}
                      value={email}
                    />
                    <FormFeedback>{emailErr}</FormFeedback>
                  </Col>
                </FormGroup>
                <FormGroup row>
                  <Button
                    style={{
                      background: 'transparent',
                      border: 'solid 1px rgb(71,108,138)',
                      color: 'rgb(71,108,138)',
                      height: '2rem',
                      lineHeight: '2rem',
                      borderRadius: '1rem',
                      padding: '0 40px',
                      float: 'right',
                      maxWidth: '300px',
                      margin: '3rem auto',
                    }}
                    onClick={onSubmit}
                  >
                    送信
                  </Button>
                </FormGroup>
              </Col>
            </div>
          </div>
          {/* 成功モーダル */}
          <SuccessModal
            isOpen={isSuccess}
            onclickOK={gotoHome}
            message="ご登録のメールアドレスにメールが送られますので、<br>メールをご確認いただき,メール内のURLをクリックしてください。"
          />
          {/* 失敗モーダル */}
          <FailureModal
            isOpen={isFailure}
            onclickOK={closeResultModal}
            message="パスワードの再設定に失敗しました。"
            detail={errorMessage}
          />
        </div>
      </div>
    </TheLayout>
  );
};

export default ResetPw;
